import { ActionTypes } from '../constants';

export function updateCurrencyInfo(payload: Object) {
    return {
        type: ActionTypes.UPDATE_CURRENCY,
        payload: { ...payload },
    };
}